import React from 'react'

import { Heading } from '../../../../components'
import { Highlight } from '../../../../components/highlight'

interface Props {
  headerLabel: string
  subHeaderLabel?: string
  highlightHeaderLabel?: string
  headerValue: string | null
  subHeaderValue: React.ReactNode
}

export function CardHeader({ headerLabel, highlightHeaderLabel, subHeaderLabel, subHeaderValue, headerValue }: Props) {
  return (
    <>
      <div className="flex">
        <Heading level={2} className="flex-1 truncate text-muted">
          <Highlight highlight={highlightHeaderLabel ?? ''} text={headerLabel} />
        </Heading>
        <Heading level={2} className="ml-4 flex-none text-muted">
          {headerValue}
        </Heading>
      </div>
      <div className="flex min-h-6">
        <Heading level={4} className="flex-1 truncate text-muted">
          {subHeaderLabel}
        </Heading>
        <Heading level={4}>{subHeaderValue}</Heading>
      </div>
    </>
  )
}
